export default __webpack_public_path__ + "static/media/sobre.d69a086f.svg";